import { Component, Input } from '@angular/core';

@Component({
  selector: 'jhi-conditional-wrapper',
  template: `
    <div *ngIf="insideDiv; else elseTpl" [class]="classDiv">
      <ng-container *ngTemplateOutlet="elseTpl"></ng-container>
    </div>

    <ng-template #elseTpl><ng-content></ng-content></ng-template>
  `
})
export class ConditionalWrapperComponent {
  @Input()
  insideDiv: boolean;
  @Input()
  classDiv: string;
}
